const styles = {
  componentWrapper: {
    display: 'flex',
    cursor: 'pointer',
  },
};

export default styles;
